var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIconFilledOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF6200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7141 12.9706C12.7141 13.0919 12.6441 13.1526 12.5041 13.1526H11.4681C11.3281 13.1526 11.2581 13.0919 11.2581 12.9706L11.0341 6.64258C11.0341 6.47458 11.1227 6.39058 11.3001 6.39058H12.6441C12.8214 6.39058 12.9101 6.47458 12.9101 6.64258L12.7141 12.9706ZM11.2301 16.4706C11.0434 16.4706 10.9501 16.3819 10.9501 16.2046V14.7486C10.9501 14.5712 11.0434 14.4826 11.2301 14.4826H12.7001C12.8961 14.4826 12.9941 14.5712 12.9941 14.7486V16.2046C12.9941 16.3819 12.8961 16.4706 12.7001 16.4706H11.2301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconFilledOrange);
export default __webpack_public_path__ + "static/media/warningIconFilledOrange.3f0f0ccf8a39516c46669ce7706412a7.svg";
export { ForwardRef as ReactComponent };